// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import VTooltip from 'v-tooltip'

Vue.config.productionTip = false;

Vue.use(VTooltip)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDSBO2ZFXsSZ4XEgxYxmeqSUnmmiPmwAjQ",
    libraries: "places"
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js